// Import Core
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({ children, location, description, title }) => {
	const site = useStaticQuery(
		graphql`
			query {
				siteMetadata: sanitySiteSettings {
					title: title
					description: description
				}
			}
		`
	);

	return (
		<>
			{/* <html lang="en" /> */}
			<title>{title ? title : site.siteMetadata.title}</title>
			{/* Remove mobile phones making numbers telephone links off the bat */}
			<meta name="format-detection" content="telephone=no"></meta>
			{/* TODO: ??? */}
			{/* <meta name="google-site-verification" content="" /> */}
			{/* Favicons added via gastby-plugin-manifest */}
			{/* Meta Tags */}
			<meta name='viewport' content='width=device-width, initial-scale=1.0' />
			<meta charSet='utf-8' />
			<meta
				name='description'
				content={description ? description : site.siteMetadata.description}
			/>
			{/* Open Graph */}
			{location && <meta property='og:url' content={location.href} />}
			<meta
				property='og:title'
				content={title ? title : site.siteMetadata.title}
				key='ogtitle'
			/>
			<meta
				propery='og:site_name'
				content={title ? title : site.siteMetadata.title}
				key='ogsitename'
			/>
			<meta
				property='og:description'
				content={description ? description : site.siteMetadata.description}
				key='ogdesc'
			/>
			{children}
		</>
	);
};

export default Seo;
